<template>
    <div class="register-card">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div class="register-body">
            <div class="reg-header">
                <span class="header-text">Registration</span>
            </div>
            <div class="reg-input-group">
                <div class="login-link">
                    <a href="/login" class="link">
                        <span class="link-text">Already have an account? Sign In</span>
                    </a>
                </div>
                <div class="full-name">
                    <div class="initials">
                        <label class="name-label" for="first-name">
                            <span class="label">First name *</span>
                        </label>
                        <input
                            required
                            class="name-input"
                            type="text"
                            name="first_name"
                            id="first-name"
                            v-model="$v.firstName.$model"
                        />
                        <span
                            class="error-form-message"
                            v-if="$v.firstName.$dirty && !$v.firstName.required"
                        >
                            First name is required.
                        </span>
                        <span
                            class="error-form-message"
                            v-else-if="$v.firstName.$dirty && !$v.firstName.minLength"
                        >
                            First Name must be more than 2 character.
                        </span>
                        <span class="error-form-message" v-else-if="firstNameValidate">
                            {{ firstNameValidate }}
                        </span>
                    </div>
                    <div class="initials">
                        <label class="name-label" for="last_name">
                            <span class="label">Last name *</span>
                        </label>
                        <input
                            class="name-input"
                            required
                            type="text"
                            name="last_name"
                            id="last_name"
                            v-model="$v.lastName.$model"
                        />
                        <span
                            class="error-form-message"
                            v-if="$v.lastName.$dirty && !$v.lastName.required"
                        >
                            Last name is required.
                        </span>
                        <span
                            class="error-form-message"
                            v-else-if="$v.lastName.$dirty && !$v.lastName.minLength"
                        >
                            Last name must be more than 2 character.
                        </span>
                        <span class="error-form-message" v-else-if="lastNameValidate">
                            {{ lastNameValidate }}
                        </span>
                    </div>
                </div>
                <div class="info-inputs">
                    <div class="input-wrapper">
                        <label class="name-label" for="phone"
                            ><span class="label">Phone *</span></label
                        >
                        <input
                            class="main-info-input"
                            type="tel"
                            v-model="$v.phone.$model"
                            name="phone"
                            id="phone"
                            maxlength="16"
                            @keydown="handleFormatPhoneNumber($event)"
                            @blur="handleFormatPhoneNumber($event)"
                        />
                        <span
                            class="error-form-message"
                            v-if="$v.phone.$dirty && !$v.phone.required"
                        >
                            A phone number is required.
                        </span>
                        <span
                            class="error-form-message"
                            v-else-if="$v.phone.$dirty && !$v.phone.phoneValidator"
                        >
                            Please enter format: (123)456-7890
                        </span>
                        <span class="error-form-message" v-else-if="phoneValidate">
                            {{ phoneValidate }}
                        </span>
                    </div>
                    <div class="input-wrapper">
                        <label class="name-label" for="email"
                            ><span class="label">Email *</span></label
                        >
                        <input
                            class="main-info-input"
                            required
                            type="email"
                            @blur="$v.email.$touch"
                            v-model="$v.email.$model"
                            name="email"
                            id="email"
                        />
                        <span
                            class="error-form-message"
                            v-if="$v.email.$dirty && !$v.email.email"
                        >
                            Valid email is required
                        </span>
                        <span
                            class="error-form-message"
                            v-if="$v.email.$dirty && !$v.email.required"
                        >
                            Field is required
                        </span>
                        <span class="error-form-message" v-else-if="emailValidate">
                            {{ emailValidate }}
                        </span>
                    </div>
                    <div class="input-wrapper">
                        <label class="name-label" for="pass"
                            ><span class="label">Password *</span></label
                        >
                        <input
                            class="main-info-input"
                            :type="passwordVisible ? 'text' : 'password'"
                            name="password"
                            id="pass"
                            @blur="$v.password.$touch"
                            v-model.trim="$v.password.$model"
                            autocomplete="new-password"
                        />
                        <i
                            class="fa"
                            :class="passwordVisible ? 'fa-eye' : 'fa-eye-slash'"
                            aria-hidden="true"
                            @click="togglePasswordVisibility()"
                        ></i>
                        <span
                            class="error-form-message"
                            v-if="$v.password.$dirty && !$v.password.required"
                        >
                            Password is required.
                        </span>
                        <span
                            class="error-form-message"
                            v-else-if="$v.password.$dirty && !$v.password.minLength"
                        >
                            Your password should contain at least
                            {{ $v.password.$params.minLength.min }} characters.
                        </span>
                        <span class="error-form-message" v-else-if="passwordValidate">
                            {{ passwordValidate }}
                        </span>
                    </div>
                </div>
                <div class="info-confirm d-flex align-items-center">
                    <div class="attestation-confirm">
                        <label class="checkbox-input">
                            <input
                                v-model="$v.agree.$model"
                                type="checkbox"
                                name="attest_confirm"
                            />
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="confirm-text">
                        By selecting the button below, I agree to Hedlyner's
                        <a href="/terms-of-service">Terms of Service</a>,
                        <a href="/payment-terms">Payment Terms</a>,
                        <a href="/refunds-and-cancellation-policy">
                            Refunds &amp; Cancellation Policy </a
                        >, <a href="/privacy-policy">Privacy Policy</a> and
                        <a href="/off-platform-policy">Off-Platform Policy</a>.
                    </div>
                </div>
                <span class="error-form-message" v-if="$v.agree.$dirty && !$v.agree.sameAs">
                    You must agree to the terms and policies.
                </span>
                <div class="call-to-action">
                    <button class="btn" @click="RegisterSuccess" :disabled="buttonDisable">
                        <span class="btn-text">Register</span>
                    </button>
                </div>
                <div class="sign-in-link">
                    <span class="sign-in"
                        ><a class="link" href="/login"
                            >Already have an account? Sign In</a
                        ></span
                    >
                </div>
                <login-footer-vue></login-footer-vue>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {
        required,
        minLength,
        email,
        maxLength,
        helpers,
        sameAs
    } from 'vuelidate/lib/validators'
    import LoginFooterVue from './parts/FooterLogin.vue'
    import useFormattedData from '@/composables/useFormattedData.js'

    const phoneValidator = helpers.regex('phoneNumbers', /^\([0-9]{3}\)[0-9]{3}-[0-9]{4}$/)

    export default {
        name: 'RegularRegister',
        components: { LoginFooterVue },
        validations: {
            firstName: { required, minLength: minLength(2), maxLength: maxLength(25) },
            lastName: { required, minLength: minLength(2) },
            email: { required, email },
            phone: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(16),
                phoneValidator
            },
            password: { required, minLength: minLength(8), maxLength: maxLength(25) },
            agree: {
                sameAs: sameAs(() => true)
            }
        },
        setup() {
            const { formatPhoneNumberInput } = useFormattedData()
            return {
                formatPhoneNumberInput
            }
        },
        data() {
            return {
                firstName: '',
                firstNameValidate: '',
                lastName: '',
                lastNameValidate: '',
                phone: '',
                phoneValidate: '',
                email: '',
                emailValidate: '',
                password: '',
                passwordValidate: '',
                agree: false,
                load: false,
                passwordVisible: false,
                buttonDisable: true
            }
        },
        watch: {
            '$v.$anyError': function (hasError, hadError) {
                if (!hasError && hadError) this.buttonDisable = false
            },
            firstName: function () {
                this.resetServerError('firstName')
            },
            lastName: function () {
                this.resetServerError('lastName')
            },
            email: function () {
                this.resetServerError('email')
            },
            phone: function () {
                this.resetServerError('phone')
            },
            password: function () {
                this.resetServerError('password')
            }
        },
        methods: {
            async RegisterSuccess() {
                if (this.formValid()) {
                    try {
                        this.load = true
                        await axios.post('/register', {
                            first_name: this.firstName,
                            last_name: this.lastName,
                            email: this.email,
                            phone_number: this.phone,
                            password: this.password,
                            password_confirmation: this.password
                        })
                        window.location.href = '/email/verify'
                    } catch (error) {
                        if (error.response.data.errors.email)
                            this.emailValidate = error.response.data.errors.email[0]
                        if (error.response.data.errors.phone_number)
                            this.phoneValidate = error.response.data.errors.phone_number[0]
                        if (error.response.data.errors.first_name)
                            this.firstNameValidate = error.response.data.errors.first_name[0]
                        if (error.response.data.errors.last_name)
                            this.lastNameValidate = error.response.data.errors.last_name[0]
                        if (error.response.data.errors.password)
                            this.passwordValidate = error.response.data.errors.password[0]

                        this.buttonDisable = true
                    } finally {
                        this.load = false
                    }
                } else {
                    this.buttonDisable = true
                }
            },
            formValid() {
                this.$v.$touch()
                return !this.$v.$invalid
            },
            resetServerError(field) {
                const serverErrorState = field + 'Validate'

                if (this[serverErrorState]) {
                    this[serverErrorState] = ''
                    this.buttonDisable = false
                }
            },
            togglePasswordVisibility() {
                this.passwordVisible = !this.passwordVisible
            },
            handleFormatPhoneNumber(event) {
                this.phone = this.formatPhoneNumberInput(event, this.phone)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .fa {
        color: #acacac;
        position: absolute;
        top: 60%;
        right: 10px;
    }
    .link {
        text-decoration: none;
        color: #cdeb09;
    }

    .register-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .register-body {
        display: flex;
        padding: min(48px, 32px) min(80px, 50px);
        flex-direction: column;
        align-items: center;
        gap: 48px;
        border-radius: 15px;
        background: #262626;
        margin-top: 100px;
        margin-bottom: 15px;
        max-width: 625px;
        min-width: 300px;
        width: 100%;
    }

    .header-text {
        color: #f5f5f5;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }

    .reg-input-group {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        max-width: 625px;
        width: 100%;
        min-width: 280px;
    }

    .link-text {
        color: #cdeb09;
        font-family: Instrument Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 130%;
        letter-spacing: 0.14px;
    }

    .full-name {
        display: flex;
        align-items: flex-start;
        gap: 20px;
        align-self: stretch;
        flex-wrap: wrap;
    }

    .initials {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        flex: 1 0 0;
    }

    .label {
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 135%;
        letter-spacing: 0.12px;
    }

    .name-input {
        display: flex;
        padding: 12px 16px 16px 16px;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        color: #f5f5f5;
    }

    .info-inputs {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        align-self: stretch;
    }

    .main-info-input {
        display: flex;
        flex: 1;
        padding: 12px 16px 16px 16px;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        color: #f5f5f5;
    }

    .input-wrapper {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        align-self: stretch;
        position: relative;
    }

    .info-confirm {
        gap: 4px;
    }

    .confirm {
        color: none;
        background: none;
    }

    .attestation-confirm {
        position: relative;
        right: 10px;
    }

    .checkmark {
        width: calc(100% - 6px);
        height: calc(100% - 6px);
        border-radius: 50%;
        background-color: white;
        display: none;
    }

    .checkbox-input {
        width: 17px;
        height: 17px;
        border: 1px solid white;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .checkbox-input > input {
        position: absolute;
        opacity: 0;
    }

    .checkbox-input > input:checked + .checkmark {
        display: inline-block;
    }

    .confirm-text {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 130%;
        letter-spacing: 0.14px;
    }

    .call-to-action {
        display: flex;
        min-width: 100%;
    }

    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 100%;
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        border: none;
    }

    .btn-text {
        color: #000;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }

    .sign-in {
        color: #cdeb09;
        font-family: Instrument Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 130%;
        letter-spacing: 0.14px;
    }

    .sign-in-link {
        display: flex;
        justify-content: center;
        min-width: 100%;
    }
    .error-form-message {
        color: #ed3c0d;
        font-family: Instrument Sans;
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: 130%;
        letter-spacing: 0.14px;
    }

    @media screen and (max-width: 600px) {
        .attestation-confirm {
            right: 3px;
        }
    }
</style>
